import {css} from "@emotion/react";
import React from 'react';


export interface SpacingProps {
    w?: number; // Width
    h?: number; // Height
}


export const Spacing: React.FC<SpacingProps> = ({
    w = 0,
    h = 0,
}) => {
    return <div css={css({
        minWidth: w * 8,
        maxWidth: w * 8,
        width: w * 8,
        minHeight: h * 8,
        maxHeight: h * 8,
        height: h * 8,
    })} />
};